import { render, staticRenderFns } from "./ReceitaUpdate.vue?vue&type=template&id=6d78829e"
import script from "./ReceitaUpdate.vue?vue&type=script&lang=js"
export * from "./ReceitaUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports